import { Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { SubmitHandler } from "react-hook-form";

import PrimaryButton from "components/PrimaryButton";
import { RequestModal, RequestModalProps } from "components/RequestModals";
import { IRM_CUSTOMER_SERVICE_PHONE_NUMBER } from "util/constants";

const FailureTryAgain = ({
  isOpen,
  customerName,
  onClose = () => {
    return;
  },
  onRetry = () => {
    return;
  },
  failureCount = 0,
}: {
  onRetry?: SubmitHandler<any>;
  failureCount?: number;
  customerName: string;
} & RequestModalProps) => {
  return (
    <RequestModal isOpen={isOpen} onClose={onClose} header={customerName}>
      <ModalBody>
        {failureCount < 2
          ? "Sorry the submission could not be completed. Would you like try again?"
          : `We are sorry but we are unsure if your request was able to be processed. Please contact IRM Customer Service at ${IRM_CUSTOMER_SERVICE_PHONE_NUMBER}.`}
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="gray" mr={3} onClick={onClose} variant="secondary">
          Cancel
        </Button>
        {failureCount < 2 ? (
          <PrimaryButton mr={3} onClick={onRetry}>
            Retry
          </PrimaryButton>
        ) : null}
      </ModalFooter>
    </RequestModal>
  );
};

export default FailureTryAgain;
